// @ts-nocheck
import { Link } from 'react-router-dom'
import * as React from 'react'
import styled from 'styled-components'

import {Content} from '../../atoms/Content/index'
import { MenuPage } from '../MenuPage'
import {media} from '../../utils/media'
// import {ReadButton} from '../../atoms/ReadButton'

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'

let cloudinaryUrlPNG: string
let cloudinaryUrlJPG: string
if (window.innerWidth < 400) {
  cloudinaryUrlPNG = 'https://res.cloudinary.com/dvjhedt3c/image/fetch/w_600,c_scale,f_png/'
  cloudinaryUrlJPG = 'https://res.cloudinary.com/dvjhedt3c/image/fetch/w_800,c_scale,f_jpg/'
} else {
  cloudinaryUrlPNG = 'https://res.cloudinary.com/dvjhedt3c/image/fetch/f_png/'
  cloudinaryUrlJPG = 'https://res.cloudinary.com/dvjhedt3c/image/fetch/f_jpg/'
}



const translations = {
  'en': {
    howItWorks: 'How it Works',
    welcomeFirstParagraph: 'Welcome to WebTIPS! Here\'s how it works: We\'re going to ask you several questions about you and your child.\n',
    welcomeSecondParagraph: ' We will then give you personalized information to help prepare you for your child\'s surgery. Once you\n' +
      '          complete your portion, your child will be able to access a special site made just for them!',
    gettingStarted: 'Getting Started',
    gettingStartedParagraph: 'There are four sections in the parent site. We recommend taking your time while reading through each section to\n' +
      '        get the full benefits of WebTIPS. Remember, you can save your place and return at any time to pick up where you\n' +
      '        left off. At the end of this program you will be able to print out all of the information you learned, including\n' +
      '        tips on what to bring to the hospital and ideas about how to keep your child calm during the surgery process.\n' +
      '        First, we\'ll ask you to answer some questions about yourself and your child. Be sure that the parent who will be\n' +
      '        at the hospital on the day of surgery fills out this information. Click the \'Start\' button when you are ready\n' +
      '        to begin.',

  },
  'es': {
    howItWorks: 'Cómo Funciona',
    welcomeFirstParagraph: '¡Bienvenidos a L-WebTIPS! Así es como funciona: le haremos algunas preguntas sobre usted y su hijo.',
    welcomeSecondParagraph: 'A continuación, le daremos información personalizada para ayudarlo a prepararse para la cirugía de su hijo. Una vez que complete el sitio de los padres, su hijo podrá acceder a un sitio especial diseñado sólo para niños.',
    gettingStarted: 'Empezando',
    gettingStartedParagraph: 'Hay cuatro secciones en el sitio para padres. Tómese su tiempo mientras lee cada sección para obtener todos los beneficios de L-WebTIPS. Recuerde que su lugar se guardará si cierra la sesión. Puede volver a entrar en cualquier momento para continuar donde lo dejó. Al final del sitio para padres, puedes imprimir toda la información que has aprendido. Esto incluye consejos sobre qué llevar al hospital e ideas sobre cómo mantener a su hijo tranquilo. En primer lugar, le pediremos que responda a algunas preguntas sobre usted y su hijo. Asegúrese de que el padre que estará en el hospital el día de la cirugía responda a las preguntas. Haga clic en el botón "Inicio" cuando esté listo para comenzar.',
  },
}

const openPreview = (event) => {
  console.log('openPreview')
  window.target = event
  document.querySelector('#videoModal').style.display = 'flex'
  document.querySelector('#introVideo').play()
}

const closePreview = (event, context) => {
  console.log('close')
  window.target = event
  document.querySelector('#videoModal').style.display = 'none'
  document.querySelector('#introVideo').pause()
  document.querySelector('#introVideo').currentTime = 0
}

// @ts-ignore
export class Welcome extends MenuPage {
  public renderContent() {
    return (
      <div>
        <span className="d-none d-sm-block">
          <Header>
            <img style={{width: '100%'}}
            src="https://s3-us-west-1.amazonaws.com/uci-images/images/screen-14-header@2x.png"/>
          <HeaderTitle>{translations[lang].howItWorks}</HeaderTitle>
        </Header>
      </span>
      <span className="d-block d-sm-none">
        <Header>
          <img style={{width: '100%'}}
          src="https://s3-us-west-1.amazonaws.com/uci-images/images/screen-14-header-m.jpg"/>
          <HeaderTitle style={{
            paddingTop: 20,
            marginTop: -130,
            paddingBottom: 45,
          }}>{translations[lang].howItWorks}</HeaderTitle>
      </Header>
    </span>
    <Content>

      <div className="row justify-content-left">
        <div style={{paddingTop: '5%', paddingLeft:'10%', paddingRight:'10%'}}>


        <H5Top >
        {translations[lang].welcomeFirstParagraph}
          </H5Top>
      </div>

        {/*
          <<div class='col-lg-6' style='display: flex;'><h5 style='display: flex; align-items: center; justify-content: center;'>We will then give you personalized information to help prepare you for your child's surgery. Once you complete your portion, your child will be able to access a special site made just for them!</h5></div></div>
        */}

    <div className="col-lg-5 flex-column" style={{paddingLeft: '10%'}}>

    <img style={{width: '100%'}}
          className="img-fluid pt-4 pt-md-0"
          src="https://s3-us-west-1.amazonaws.com/uci-images/images/webtips-first-1_ES.png"/>
        </div>
        <div style={{display: 'flex'}} className="col-lg-6">
          <p   style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            {translations[lang].welcomeSecondParagraph}
        </p>
      </div>
    </div>
    <div className="row justify-content-center"><div className="col-lg-6">

      <H5> {translations[lang].gettingStarted} </H5>
      <div>
        {translations[lang].gettingStartedParagraph}
      </div>
    </div>
    <div className="col-lg-4 flex-column">
      <Link to="/contents/disclaimer-webtips">
        <img style={{width: '100%', cursor: 'pointer'}}
        className="img-fluid pt-4 pt-md-0"
        src="https://s3-us-west-1.amazonaws.com/uci-images/images/webtips-first-2_ES.png"/>
      </Link>
    </div>
  </div>
      {lang === 'es' && (
        <>
        <div className="row justify-content-left"  style={{paddingTop: '5%', paddingLeft:'10%', paddingRight:'10%'}}>


          <div className={'videoPreview'} onClick={(e) => openPreview(e)}>
            <img src={`https://res.cloudinary.com/dvjhedt3c/image/fetch/f_jpg/https://s3-us-west-1.amazonaws.com/uci-images/images/Tutorial.mp4.jpg`}
                 srcSet={`https://res.cloudinary.com/dvjhedt3c/image/fetch/f_jpg/https://s3-us-west-1.amazonaws.com/uci-images/images/Tutorialmp4@2x.jpg`}/>
            <img src="https://s3-us-west-1.amazonaws.com/uci-images/images/whitePlay.png"
                 className="whitePlay"/>
              <div className="videoPreviewText">
                <span className="videoTitle">Tutorial L-Webtips</span><br/>
                <span className="videoSubtitle">Aprenda cómo funciona L-WebTIPS</span>
              </div>
          </div>
          <div className="videoModal" id={'videoModal'}>

            <div className="show-big flex-column">
              <div className="videoContainer">
                <div className="videoRow">
                  <div className="videoCol">
                    <div className="videoModalTitle">Tutorial L-Webtips</div>
                    <div className="videoModalDescription2">Aprenda cómo funciona L-WebTIPS</div>
                    <img onClick={(e) => {
                      closePreview(e, this)
                      return true
                    }}
                         src="https://res.cloudinary.com/dvjhedt3c/image/fetch/https://s3-us-west-1.amazonaws.com/uci-images/images/videoClose.png"
                         srcSet="https://res.cloudinary.com/dvjhedt3c/image/fetch/https://s3-us-west-1.amazonaws.com/uci-images/images/videoClose@2x.png 2x"
                         style={{height: '36px', width: '86px', marginTop: '34px'}}/>
                  </div>
                  <div className="videoCol">
                    <video id="introVideo" className="video-js vjs-4-3" controls preload="auto" width="640" height="264" title="Tutorial"
                           data-setup="{}" style={{width:'100%', height: '100%', padding: 0}}>
                      <source src="https://uci-images.s3-us-west-1.amazonaws.com/video/p1/L-WebTIPS+Final+Tutorial.mp4" type="video/mp4"/>
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row justify-content-left"  style={{paddingTop: '5%', paddingLeft:'10%', paddingRight:'10%'}}>

        <div id="accordion" className="accordion" style={{width: '100%'}}>
          <div className="card" >
            <div className="m-2 accordion-item-header" id="accordion-item-header-0">
              <h5 className="mb-0">
                <button className="btn collapsed" data-toggle="collapse" data-target="#accordion-item-0" aria-expanded="false"
                        aria-controls="accordion-item-0">
                  <div className="accordion-item-title">Citas para L-WebTIPS</div>
                  <div className="accordion-item-header-arrow"/>
                </button>
              </h5>
            </div>
            <div id="accordion-item-0" className="accordion-item collapse"
                 aria-labelledby="accordion-item-header-0" data-parent="#accordion">
              <div className="card-body">
                <p>La intervención está basada en la evidencia y se adapta a las características individuales del padre
                  y el niño. La información provista se desarrolló en colaboración con partes interesadas, incluidos
                  pacientes, padres y miembros del equipo de atención médica perioperatoria.<sup>1,2</sup> L-WebTIPS se basa en
                  muchos años de trabajo en psicología, pediatría y manejo del dolor. Consulte nuestra página Sobre para
                  aprender más sobre nuestra investigación.</p>
                <p>1. <strong>Kain ZN</strong>, <a
                  href="https://journals.lww.com/anesthesia-analgesia/Fulltext/2015/04000/Web_Based_Tailored_Intervention_for_Preparation_of.31.aspx"
                  >Fortier M, Chorney J, Mayes L. Web-based Tailored Intervention for Preparation of
                  Parents and Children for Outpatient Surgery (WebTIPS): Development</a>. <i>Anesth
                  Analg</i> 2015;120:905–914</p>
                <p>2. Fortier MA, <strong>Kain ZN</strong>, <a
                  href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4261033/" >Treating perioperative
                  anxiety and pain in children: a tailored and innovative approach</a>. <i>Paediatr
                  Anaesth</i> 2015;25:27-35</p>
              </div>
            </div>
          </div>
        </div>
        </div>
        <br/>
        <br/>
        </>
      )}

</Content>
      </div>
      )
  }
}

export default Welcome

const Header = styled.header`
width: 100%;
position: relative;
`

const H5 = styled.h5`
@media (max-width: 575px) {
  margin-top: 20px;
}
`

const HeaderTitle = styled.div`
display: flex;
justify-content: center;
margin-top: -130px;
margin-left: auto;
margin-right: auto;
left: 40px;
right: 40px;
max-width: 1000px;
width: auto;
bottom: 40px;
font-size: 2rem;
color: white;

  ${media.desktop`
    margin-top: -160px;
    font-size: 3rem;
  `}

  @media (max-width: 575px) {
    margin-top: -65px;
  }
  `

  const H5Top = styled.h5`
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  `

  const HeaderText = styled.div`
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  left: 40px;
  right: 40px;
  max-width: 1000px;
  width: auto;
  bottom: 40px;
  text-align: center
  font-size: 1.2rem;
  color: white;

    ${media.desktop`
      font-size: 1.5rem;
    `}
    `

    const SMtext = styled.p`
    display: none;
    @media (max-width: 575px) {
      margin-top: 15px;
      display: -webkit-box;
      font-family: "SF Pro Display";
      font-size: 20px;
      color: #172129;
      line-height: 24px;
      margin: 14px 0;
    }
    `



// WEBPACK FOOTER //
// ./src/pages/Welcome/index.tsx